import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Subheading,
  Block,
} from "../styles/components/Global/Text";
import animations from "./Animations";

const SplitText = ({ text, width, align, textAlign, indent, parallax }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <TextContainer
      ref={containerRef}
      $align={align}
      $direction="row"
      $mobileRow
      $flex
    >
      <Block />
      <Subheading
        $width={width}
        $textAlign={textAlign}
        $indent={indent}
        dangerouslySetInnerHTML={{ __html: text }}
      ></Subheading>
    </TextContainer>
  );
};

SplitText.defaultProps = {
  width: "small",
  align: "stretch",
  textAlign: "left",
  indent: false,
  parallax: true,
};

export default SplitText;
